exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component-fade-enter-active[data-v-6b96f8ac],.component-fade-leave-active[data-v-6b96f8ac]{transition:opacity .3s ease}.component-fade-enter[data-v-6b96f8ac],.component-fade-leave-to[data-v-6b96f8ac]{opacity:0}.menu-container[data-v-6b96f8ac]{display:flex;width:100%;max-width:36rem;column-gap:.5rem;border-radius:.25rem;background:linear-gradient(180deg,#e9e9e9 0,#ddd);margin-left:auto;margin-right:auto;margin-bottom:1rem;color:rgba(0,0,0,.5)}.menu-container span[data-v-6b96f8ac]{cursor:pointer;width:100%;text-align:center;padding:.5rem}.menu-container span[data-v-6b96f8ac]:hover:not(.active){color:rgba(0,0,0,.7)}.active[data-v-6b96f8ac]{color:#ff6200}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6b96f8ac&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/Employees.vue
// module id = 243
// module chunks = 0